// utils/India/useIndiaV2Copy.ts
//
// India V2/V3 ships its own copy for English, Hindi, Tamil and Marathi. For
// every other app language this returns the English copy with each sentence
// replaced by its translation from the locale files ("laneCopy.indiaV2.*"),
// including the three templated strings (step counter, percent, name hint).
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLaneCopy } from "../laneCopy";
import { ASTRIA_INDIA_V2_COPY } from "./astriaIndiaV2Copy";
import type { IndiaV2Language } from "./astriaIndiaV2Language";

export function useIndiaV2Copy(lang: IndiaV2Language) {
  const { t } = useTranslation();
  const base = useLaneCopy("indiaV2", ASTRIA_INDIA_V2_COPY, lang);
  return useMemo(() => {
    if (lang !== "en") return base;
    return {
      ...base,
      shared: {
        ...base.shared,
        stepOf: (step: number, total: number) =>
          t("laneCopy.indiaV2fn.stepOf", { step, total }),
        percentComplete: (pct: number) =>
          t("laneCopy.indiaV2fn.percentComplete", { pct }),
      },
      vivah: {
        ...base.vivah,
        namePlaceholder: (person: string) =>
          t("laneCopy.indiaV2fn.namePlaceholder", { person }),
      },
    };
  }, [base, lang, t]);
}
